import _extends from '@babel/runtime/helpers/esm/extends';
import React__default, { useContext } from 'react';
import { InputGroup as InputGroup$1 } from '@blueprintjs/core';
import { formGroupContext } from '../form-group/form-group.js';

var InputGroup = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var formContext = useContext(formGroupContext);

  if (props.id !== undefined && formContext && props.id !== (formContext === null || formContext === void 0 ? void 0 : formContext.labelFor)) {
    console.warn("Warning: InputGroup with id of \"".concat(props.id, "\" has a parent FormGroup with a missing or mismatched labelFor prop."));
  }

  return /*#__PURE__*/React__default.createElement(InputGroup$1, _extends({
    inputRef: ref !== null && ref !== void 0 ? ref : undefined,
    "aria-labelledby": formContext === null || formContext === void 0 ? void 0 : formContext.labelId,
    id: props.id ? props.id : formContext !== null && formContext !== void 0 && formContext.labelId ? "element-".concat(formContext === null || formContext === void 0 ? void 0 : formContext.labelId) : undefined
  }, props));
});

export { InputGroup };
//# sourceMappingURL=input-group.js.map
